const routes = {
  index: {
    path: 'index.consult.owner',
    url: '/proprietaire',
  },
  home: {
    path: 'index.consult.owner.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.owner.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.owner.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.owner.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/owner/routes.js